
import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import Parts from './index.js'


if (!store?.state?.['Parts']) {
	store.registerModule('Parts', Parts)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('Parts')
